import { ChevronDown, ChevronRight } from "lucide-react";
import { Switch } from "../../components/ui/switch";

/**
 * Cartão colapsável de um módulo (Recepção, Atendimento…). Com `ligado`
 * definido, a chave do cabeçalho liga/desliga o módulo inteiro; desligado, os
 * itens ficam visíveis mas apagados.
 */
export default function Modulo({ icone: Icone, titulo, descricao, aberto, onToggle, ligado, onLigar, children }) {
  const desligado = ligado === false;
  return (
    <section className={`rounded-2xl border bg-card overflow-hidden transition-colors ${desligado ? "border-dashed" : "hover:border-primary/30"}`}>
      <div className="flex items-center gap-3 px-4 py-3">
        <button type="button" onClick={onToggle} className="flex flex-1 items-center gap-3 text-left min-w-0">
          {aberto ? <ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground" /> : <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />}
          {Icone && (
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-[#25d366]/10">
              <Icone className="h-4 w-4 text-[#0a7d5a] dark:text-[#4ade80]" />
            </span>
          )}
          <span className="min-w-0">
            <span className="block font-semibold">{titulo}</span>
            <span className="block text-xs text-muted-foreground">{descricao}</span>
          </span>
        </button>
        {ligado !== undefined && (
          <label className="flex shrink-0 items-center gap-2 text-xs font-medium text-muted-foreground">
            {desligado ? "Desligado" : "Ligado"}
            <Switch checked={!desligado} onCheckedChange={onLigar} />
          </label>
        )}
      </div>
      {aberto && (
        <div className={`border-t bg-muted/10 px-4 py-4 space-y-3 ${desligado ? "opacity-50" : ""}`}>
          {children}
        </div>
      )}
    </section>
  );
}
